import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  // props: ['options'],
  data() {
    return {
      options: {
        title: {
          // display: true,
          display: false,
          text: 'Due',
          fontSize: 16,
          fontFamily: 'Nunito',
          padding: 0,
          fontColor: '#38406a'
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                precision: 0
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: function (tooltipItems) {
              return `${tooltipItems.xLabel}: ${tooltipItems.yLabel}`
            }
          }
        },
        responsive: true,
        aspectRatio: 1,
        layout: {
          padding: {
            top: 25
          }
        }
      }
    }
  },
  methods: {
    update() {
      this.$data._chart.update()
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
